<router-outlet></router-outlet>
<div class="loader_data hide_elements" id="loader_data">
    <div class="loader_data_center">
        <div class="pace-demo text-center bg-teal-800">
            <div class="theme_radar theme_radar_with_text">
                <div class="pace_progress" data-progress-text="60%" data-progress="60"></div>
                <div class="pace_activity"></div>
                <span>Loading Data</span>
            </div>
        </div>
    </div>
</div>